import React from "react";
import { useParams, useLocation, useSearchParams } from "wouter";
import { Alert } from "../../../../components/src/Alert";

import { Panel } from "../../../../components/src/common/Panel";

import { useQueryState } from "../../../../components/src/use-query-state";
import { DateForm } from "../../../../components/src/dateForm";
import { Reports } from ".";
import { MiniTransactionForm } from "../../containers/MiniTransactionForm";
import { PmSelectPrompt } from "./PmSelectPrompt";

export interface Props {
    lookThrough: boolean;
}

const check_today_date = (endDate: string) => {
    const today = new Date().toISOString().slice(0, 10);
    if (endDate === today) {
        return true;
    } else {
        return false;
    }
};

export const ReportsView = (props: Props): React.ReactElement => {
    const [queryArgs] = useSearchParams();
    const [, navigate] = useLocation();
    const [endDate] = useQueryState("endDate", new Date().toISOString().slice(0, 10));

    const { id, tab, type, transactionId }: any = useParams();

    if (typeof id === "undefined" || id === "all") {
        return <PmSelectPrompt message="Select a client" />;
    }

    return (
        <div>
            <div className="flex">
                <DateForm defaultDateString={endDate} dateName="endDate"></DateForm>
                {!check_today_date(endDate) ? (
                    <Alert variant="danger" className="ml-2">
                        Historical or future date selected
                    </Alert>
                ) : null}
            </div>
            <br />
            <div className="flex flex-wrap -mx-2">
                <div className={"w-full px-2"}>
                    <Reports clientIds={[id]} endDate={endDate as string} lookThrough={props.lookThrough} />
                </div>
            </div>
            <Panel
                isOpen={transactionId && tab === "positions"}
                onDismiss={() => navigate(`/pm/${id}/positions/${queryArgs.toString() ? `?${queryArgs.toString()}` : ""}`)}
                title="Close derivative trade"
            >
                <MiniTransactionForm
                    clientId={id ? id : "000000000000000000000000"}
                    id={transactionId && type === "closederivativetrade" ? transactionId : null}
                    type={"CloseDerivativeTrade"}
                    parentId={transactionId && type === "newclosederivativetrade" ? transactionId : null}
                />
            </Panel>
        </div>
    );
};
